import React from 'react';
import { Form } from 'semantic-ui-react';

const TenoviWeightScale = ({
  tenoviDeviceTypes,
  setTenoviDeviceTypes,
}) => {
  return (
    <>
      <Form.Group inline>
        <label style={{ width: '150px' }}>Weight Scale</label>
        <Form.Radio
          label="Request"
          value="request"
          checked={tenoviDeviceTypes.TENOVI_SCALE.state === 'request'}
          onChange={(e, { value }) =>
            setTenoviDeviceTypes({
              ...tenoviDeviceTypes,
              TENOVI_SCALE: {
                ...tenoviDeviceTypes.TENOVI_SCALE,
                state: value,
              },
            })
          }
        />
        <Form.Radio
          label="Connect"
          value="connect"
          checked={tenoviDeviceTypes.TENOVI_SCALE.state === 'connect'}
          onChange={(e, { value }) =>
            setTenoviDeviceTypes({
              ...tenoviDeviceTypes,
              TENOVI_SCALE: {
                ...tenoviDeviceTypes.TENOVI_SCALE,
                state: value,
              },
            })
          }
        />
        <Form.Radio
          label="Not needed"
          value="notNeeded"
          checked={
            tenoviDeviceTypes.TENOVI_SCALE.state === 'notNeeded'
          }
          onChange={(e, { value }) =>
            setTenoviDeviceTypes({
              ...tenoviDeviceTypes,
              TENOVI_SCALE: {
                ...tenoviDeviceTypes.TENOVI_SCALE,
                state: value,
              },
            })
          }
        />
      </Form.Group>
    </>
  );
};

export default TenoviWeightScale;
